// extracted by mini-css-extract-plugin
export default {"teamMemberCard":"TeamCard_teamMemberCard__gpbEe"};